import React from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import SVGTitle from "./SVGTitle";

function About() {
  const { t, i18n } = useTranslation();
  const dir = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <div className="about py-5 my-5 overflow-hidden" id="about" dir={dir}>
      <Helmet>
        <html lang={i18n.language} dir={dir} />
        <title>{t("about.seo.title")}</title>
        <meta name="description" content={t("about.seo.description")} />
        <meta name="keywords" content={t("about.seo.keywords")} />
        <meta property="og:title" content={t("about.seo.ogTitle")} />
        <meta
          property="og:description"
          content={t("about.seo.ogDescription")}
        />
        <meta
          property="og:image"
          content="https://slimsmile.ps/images/about.jpg"
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="head text-center">
        <h2 className="mb-4 fs-1 fw-bolder">{t("about.title")}</h2>
        <SVGTitle />
      </div>

      <div className="container mt-5">
        <div className="row align-items-center">
          <motion.div className="col-md-6">
            <h3 className="py-2 fw-bold">{t("about.heading")}</h3>
            <p>{t("about.paragraph1")}</p>
            <p>{t("about.paragraph2")}</p>
            <p>{t("about.paragraph3")}</p>
            <p>{t("about.paragraph4")}</p>
            <h5 className="mt-3 text-info fw-bold">{t("about.slogan")}</h5>
            <a href="#contact" className="btn btn-info my-3 px-4">
              {t("about.button")}
            </a>
          </motion.div>
          <motion.div
            className="col-md-6 d-none d-md-block"
            initial={{ opacity: 0, x: dir === "rtl" ? 100 : -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
          >
            <img
              src="/assets/about/about.jpg"
              alt="About Slim Smile"
              className="img-fluid rounded-4"
              loading="lazy"
              decoding="async"
              width="600"
              height="450"
              style={{ objectFit: "cover" }}
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default About;
